import { selectUser } from "../redux/reducers/userReducer";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

export const useOnlyAdminUsers = () => {
  const user = useSelector(selectUser);
  const navigate = useNavigate();

  useEffect(() => {
    if (
      !user.data?.user.user_id ||
      (user.data?.user.userType !== "admin" &&
        user.data?.user.userType !== "writer")
    ) {
      navigate("/");
    }
    return () => {};
  }, [user.data?.user.user_id]);
};
